import { api } from 'store/api';
import { ApiResponse } from 'store/api/types';

import { CoaAccountRow, CoaTemplate } from './models';
import { TOKEN_ID_HEADER } from 'store/app/constants';

export interface FetchChartOfAccountsTemplatesResponse extends ApiResponse {
  data: { templates: CoaTemplate[] };
}

export const fetchChartOfAccountsTemplates =
  (): Promise<FetchChartOfAccountsTemplatesResponse> =>
    api.get<FetchChartOfAccountsTemplatesResponse>(`/coa/templates`);

export interface FetchChartOfAccountsByCountryResponse extends ApiResponse {
  data: { accounts: CoaAccountRow[] };
}

export const fetchChartOfAccountsByCountry = (
  countryId: string
): Promise<FetchChartOfAccountsByCountryResponse> =>
  api.get<FetchChartOfAccountsByCountryResponse>(`/coa/country/${countryId}`);

export interface FetchChartOfAccountsForOrganisationResponse
  extends ApiResponse {
  data: { accounts: CoaAccountRow[] };
}

export const fetchChartOfAccountsForOrganisation = (
  organisationId: string
): Promise<FetchChartOfAccountsForOrganisationResponse> =>
  api.get<FetchChartOfAccountsForOrganisationResponse>(
    `/coa/${organisationId}`,
    {
      headers: { [TOKEN_ID_HEADER]: organisationId },
    }
  );

export const saveChartOfAccounts = (
  organisationId: string,
  accountsIds: string[]
): Promise<ApiResponse> =>
  api.post<ApiResponse>(`/coa/${organisationId}`, {
    body: { accounts: accountsIds },
    headers: { [TOKEN_ID_HEADER]: organisationId },
  });

export const deleteChartOfAccountRow = (
  organisationId: string,
  accountId: string
): Promise<ApiResponse> =>
  api.delete<ApiResponse>(`/coa/${organisationId}/${accountId}`, {
    headers: { [TOKEN_ID_HEADER]: organisationId },
  });

export const saveChartOfAccountsTemplate = (
  organisationId: string,
  name: string,
  accountsIds: string[]
): Promise<ApiResponse> =>
  api.post<ApiResponse>(`/coa/template/${organisationId}`, {
    body: { name: name, accounts: accountsIds },
    headers: { [TOKEN_ID_HEADER]: organisationId },
  });

export const deleteChartOfAccountTemplate = (
  templateId: string
): Promise<ApiResponse> =>
  api.delete<ApiResponse>(`/coa/template/${templateId}`);

export const createChartOfAccountsCustomRow = (
  organisationId: string,
  chartOfAccountsRow: CoaAccountRow
): Promise<ApiResponse> =>
  api.post<ApiResponse>(`/coa/custom/account/${organisationId}`, {
    body: chartOfAccountsRow,
    headers: { [TOKEN_ID_HEADER]: organisationId },
  });

export const updateChartOfAccountsCustomRow = (
  organisationId: string,
  chartOfAccountsRow: CoaAccountRow
): Promise<ApiResponse> =>
  api.put<ApiResponse>(`/coa/custom/account/${organisationId}`, {
    body: chartOfAccountsRow,
    headers: { [TOKEN_ID_HEADER]: organisationId },
  });

export const updateChartOfAccountsTemplateName = (
  templateId: string,
  name: string
): Promise<ApiResponse> =>
  api.put<ApiResponse>(`/coa/template/${templateId}`, {
    body: { name: name },
  });
